import React from 'react'
import { CreateInvoiceConfigFlowProvider } from './context/CreateInvoiceConfigFlowProvider'
import { CreateInvoiceConfigFlowMain } from './components/CreateInvoiceConfigFlowMain'

export const CreateInvoiceConfigFlow = () => {
  return (
    <CreateInvoiceConfigFlowProvider>
      <CreateInvoiceConfigFlowMain />
    </CreateInvoiceConfigFlowProvider>
  )
}
